var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value && _vm.relative)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltip ? _vm.dateValue : null,
    delay: { show: 500, hide: 0 }
  }),expression:"{\n    content: tooltip ? dateValue : null,\n    delay: { show: 500, hide: 0 }\n  }"}]},[_vm._v(" "+_vm._s(_vm.relativeValue)+" "+_vm._s(_vm.suffix ? "ago" : null)+" ")]):(_vm.value)?_c('span',[_vm._v(_vm._s(_vm.dateValue)+" "+_vm._s(_vm.suffix ? "ago" : null))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }